import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  cursor: pointer;
`;

const DepotIcon = ({ width = 22, height = 33, color = '#000' }) => (
  <Wrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 33"
      fill={color}
      style={{ display: 'block', margin: 'auto' }}
    >
      <path
        d="M20.526 16.5L11.014 33l-9.55-16.5A11.015 11.015 0 015.536 1.462 11.015 11.015 0 0111.014 0 11 11 0 0122 11.016a11 11 0 01-1.474 5.484zM11.011 29l7.783-13.5A9.005 9.005 0 0020 11.013a8.94 8.94 0 00-2.627-6.367A8.942 8.942 0 0011.015 2a9.044 9.044 0 00-4.484 1.2 8.958 8.958 0 00-4.215 5.464 8.95 8.95 0 00.878 6.838z"
        data-name="Group 1509"
      />
      <circle
        data-name="Ellipse 305"
        cx="3"
        cy="3"
        r="3"
        transform="translate(8 8)"
      />
    </svg>
  </Wrapper>
);

export default DepotIcon;
